import { useEffect, useMemo } from 'react';
import DefaultLayout from '../../layout/DefaultLayout';
import UniversalRecordTable from '../../components/Tables/universalRecord/UniversalRecordTable';
import { branchColumns } from '../../features/branches/branchColumns';
import BranchRegistrationPopup from '../../components/Branch/BranchRegistrationPopup';
import BranchViewPopup from '../../components/Branch/BranchViewPopup';
import { useBranchConfiguration } from '../../hooks/branches/useBranchConfiguration';
import BranchEditPopup from '../../components/Branch/BranchEditPopup';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';

const BranchConfigurationPage = () => {
  const {
    list, // listado de sucursales
    paginator, // datos de paginador
    fetchBranchesPaged, // handler para cargar paginadas
    loadBranchById,
    showRegistrationModal,
    openAddBranchModal,
    closeAddBranchModal,
    toggleStatus,
    saveBranch,
    showViewModal,
    closeViewModal,
    showEditModal,
    closeEditModal,
  } = useBranchConfiguration();

  // Tamaño de página y página actual desde paginator
  const pageSize = paginator?.size || 10;
  const currentPage = paginator?.number || 0;

  useEffect(() => {
    fetchBranchesPaged(currentPage, pageSize);
  }, []);

  const columns = useMemo(() => branchColumns, []);

  const handlePageChange = (page: number) => {
    fetchBranchesPaged(page, pageSize);
  };

  const handlePageSizeChange = (size: number) => {
    fetchBranchesPaged(0, size);
  };

  const getActions = (row: any) => {
    const actions = [
      {
        key: 'view',
        label: 'Ver',
        onClick: async () => {
          // Cargar detalle y abrir modal de vista
          await loadBranchById(row.id, 'view');
        },
      },
      {
        key: 'edit',
        label: 'Editar',
        onClick: async () => {
          // Cargar detalle y abrir modal de edición
          await loadBranchById(row.id, 'edit');
        },
      },
      {
        key: 'cancel',
        label: row.active ? 'Desactivar' : 'Activar',
        onClick: async () => {
          // Cambiar estado de la sucursal
          await toggleStatus(row.id);
        },
      },
    ];
    return actions;
  };

  return (
    <DefaultLayout>
      <BreadcrumbTwo/>

      <UniversalRecordTable
        columns={columns}
        data={list}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        paginator={paginator}
        showPagination={true}
        enableRowClick={true}
        pageSize={pageSize}
        noDataMessage="No hay sucursales registradas."
        topRightAction={{
          label: 'Nueva Sucursal',
          onClick: openAddBranchModal,
        }}
        getActions={getActions}
      />

      {/* Modal para registrar una nueva sucursal */}
      <BranchRegistrationPopup
        isOpen={showRegistrationModal}
        onClose={closeAddBranchModal}
        onSubmit={saveBranch}
      />

      <BranchEditPopup
        isOpen={showEditModal}
        onClose={closeEditModal}
        onSubmit={saveBranch}
      />

      {/* Modal para ver detalle de sucursal */}
      <BranchViewPopup isOpen={showViewModal} onClose={closeViewModal} />
    </DefaultLayout>
  );
};

export default BranchConfigurationPage;
